import React, { useEffect, useState } from 'react'

//axios
import axios from 'axios'
import ScrollContainer from 'react-indiana-drag-scroll'

//constantes
import * as Constant from '../../global/const'

//imagenes
import noimage from '../../assets/images/base-1.png'

const PasoPasoComponent = () => {

    const [pasoPaso, setPasoPaso] = useState()

    const getPasoPaso = () => {
        axios.get(Constant.GETPASOPASO).then((response) => {
            setPasoPaso(response.data)
        }).catch((err) => {

        })
    }

    useEffect(() => {
        getPasoPaso()
    }, [])

    return (
        <div className="paso-paso">
            {//<ScrollContainer horizontal={true} hideScrollbars={false} nativeMobileScroll={true} hideScrollbars={true}>
            }
            <div className='Scroll'>
                <div className="paso">
                    {pasoPaso ?
                        Object.keys(pasoPaso).map((index) =>
                            <div className="content-paso" key={index}>
                                <div className="container-paso" key={index}>
                                    <img className="img-paso" key={index}
                                        src={Constant.URL_BASE_IMAGES + 'Web/HomePasoPaso/' + pasoPaso[index].id + '.png?' + Math.random()}
                                        onError={(e) => { e.target.onerror = null; e.target.src = noimage }}>
                                    </img>
                                    <span key={index}>
                                        <h1 key={index} style={{ color: pasoPaso[index].c_titulo }} >{pasoPaso[index].titulo}</h1>
                                        <p key={index} style={{ color: pasoPaso[index].c_descripcion }} >{pasoPaso[index].descripcion}</p>
                                    </span>
                                </div>
                            </div>
                        )
                        : null}
                </div>
            </div>
        </div>
    )
}

export default PasoPasoComponent;
